import React from 'react';

import EmployerTeam from 'Components/EmployerTeam';
import Footer from 'Components/Footer';
import Header from 'Components/Header';
import OurTeam from 'Components/OurTeam';
import TeamHr from 'Components/TeamHr';
import WorkerCoordinators from 'Components/WorkerCoordinators';
import WorkerRecruiter from 'Components/WorkerRecruiter';

export default function Team() {
  return (
    <>
      <Header />
      <OurTeam bg='bg' overlay='dark' />
      <EmployerTeam bg='black__bgr' overlay='dark' />
      <WorkerRecruiter bg='bg' overlay='dark' />
      <WorkerCoordinators bg='black__bgr' overlay='dark' />
      <TeamHr bg='bg' overlay='dark' />
      <Footer />
    </>
  );
}
